"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupUserAssignDialog = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const core_1 = require("@material-ui/core");
const lab_1 = require("@material-ui/lab");
const core_ui_1 = require("@sierralabs/core-ui");
const useFindUsers_1 = require("../../hooks/useFindUsers");
const useAddGroupUsers_1 = require("../hooks/useAddGroupUsers");
const StyledListItemText = (0, styled_components_1.default)(core_1.ListItemText) `
  .primary-text {
    font-size: 15px;
  }
  .id-text {
    color: ${props => props.theme.palette.text.secondary};
  }
`;
const GroupUserAssignDialog = props => {
    const { open, groupId, onCancel, onAssign } = props;
    const onAssignRef = (0, react_1.useRef)(onAssign);
    onAssignRef.current = onAssign;
    const [search, setSearch] = (0, react_1.useState)('');
    const [error, setError] = (0, react_1.useState)();
    const [selectedUsers, setSelectedUsers] = (0, react_1.useState)([]);
    const debouncedSearch = (0, core_ui_1.useDebounce)(search, 300);
    const { data: userList, isLoading: isFinding, get } = (0, useFindUsers_1.useFindUsers)();
    const { group: updatedGroup, isLoading: isUpdating, error: updateError, addGroupUsers } = (0, useAddGroupUsers_1.useAddGroupUsers)(groupId);
    const isLoading = isFinding || isUpdating;
    const handleCancel = () => {
        if (!isUpdating) {
            onCancel === null || onCancel === void 0 ? void 0 : onCancel();
        }
    };
    const getUsersWithParams = (0, react_1.useCallback)(() => {
        const params = {};
        if (debouncedSearch) {
            params.search = debouncedSearch;
        }
        get(params);
    }, [debouncedSearch, get]);
    // clear state
    (0, react_1.useEffect)(() => {
        if (!open) {
            setSearch('');
            setError(undefined);
            setSelectedUsers([]);
        }
    }, [open]);
    (0, react_1.useEffect)(() => {
        open && getUsersWithParams();
    }, [open, getUsersWithParams]);
    (0, react_1.useEffect)(() => {
        var _a;
        if (updatedGroup) {
            (_a = onAssignRef.current) === null || _a === void 0 ? void 0 : _a.call(onAssignRef);
        }
    }, [updatedGroup]);
    (0, react_1.useEffect)(() => {
        setError(updateError);
    }, [updateError]);
    return (react_1.default.createElement(core_1.Dialog, { fullWidth: true, maxWidth: 'sm', open: open, onClose: handleCancel },
        isLoading && react_1.default.createElement(core_1.LinearProgress, null),
        react_1.default.createElement(core_1.DialogTitle, null, "Add Employees to Team"),
        react_1.default.createElement(core_1.DialogContent, null,
            react_1.default.createElement(core_1.DialogContentText, null, "Search for an employee that you would like to assign to this team."),
            react_1.default.createElement(core_1.Box, { mt: 1, mb: 2 },
                react_1.default.createElement(lab_1.Autocomplete, { multiple: true, value: selectedUsers, options: (userList === null || userList === void 0 ? void 0 : userList.data) || [], getOptionLabel: option => {
                        return `${option.firstName} ${option.lastName} (${option.email})`;
                    }, getOptionSelected: (option, value) => option.id === value.id, onInputChange: (_, value) => setSearch(value), onChange: (_, value) => setSelectedUsers(value), renderInput: params => (react_1.default.createElement(core_1.TextField, Object.assign({}, params, { fullWidth: true, variant: 'outlined', placeholder: 'Search Employees' }))), renderOption: option => {
                        var _a;
                        return (react_1.default.createElement(StyledListItemText, { disableTypography: true, primary: react_1.default.createElement(react_1.default.Fragment, null,
                                react_1.default.createElement(core_1.Typography, { variant: 'body1', className: 'primary-text' },
                                    option.firstName,
                                    " ",
                                    option.lastName,
                                    ' ',
                                    react_1.default.createElement("span", { className: 'id-text' },
                                        "(USER-",
                                        option.id,
                                        ")")),
                                react_1.default.createElement(core_1.Typography, { variant: 'caption', color: 'textSecondary' }, option.email)), secondary: react_1.default.createElement(core_1.Typography, { variant: 'body2', color: 'textSecondary' }, (_a = option.groups) === null || _a === void 0 ? void 0 : _a.map(g => g.name).join(', ')) }));
                    } })),
            error && react_1.default.createElement(lab_1.Alert, { severity: 'error' }, error.message)),
        react_1.default.createElement(core_1.DialogActions, null,
            react_1.default.createElement(core_1.Button, { disabled: isUpdating, onClick: handleCancel }, "Cancel"),
            react_1.default.createElement(core_1.Button, { color: 'primary', variant: 'contained', disabled: isUpdating || selectedUsers.length === 0, endIcon: isUpdating && react_1.default.createElement(core_1.CircularProgress, { size: 20, color: 'primary' }), onClick: () => {
                    addGroupUsers({ userIds: selectedUsers.map(u => u.id) });
                } }, "Assign"))));
};
exports.GroupUserAssignDialog = GroupUserAssignDialog;
exports.default = exports.GroupUserAssignDialog;
//# sourceMappingURL=GroupUserAssignDialog.js.map